import styled from 'styled-components';

import { breakpoints } from '~/design-tokens/breakpoints/breakpoints';
import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const HeaderCategoryGroupRoot = styled.section`
  display: flex;
  align-items: center;
`;

export const HeaderCategoryTitle = styled.h4`
  color: var(--text-soft);
  text-transform: uppercase;
  ${typographyV2.bodyXs};
  padding: 0 8px 0 24px;
`;

export const HeaderItems = styled.nav`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 8px;

  &.options {
    gap: 0px;
  }

  @media ${breakpoints.xl} {
    gap: 12px;
  }
`;
